<template>
  <v-card class="buyoffers-table">
    <v-card-title class="toolbar white--text">
      <h2>Buy offers ({{ filteredItems.length }} of {{ pagination.totalItems }} )</h2>
      <div
        v-if="selected.length > 0"
        class="ml-3"
      >
        <v-tooltip
          top
          dark
        >
          <template v-slot:activator="{ on }">
            <v-btn
              dark
              flat
              icon
              @click="cancelModalOpen = true"
              v-on="on"
            >
              <v-icon>cancel_schedule_send</v-icon>
            </v-btn>
          </template>
          <span>Cancel Buy Offer(s)</span>
        </v-tooltip>
      </div>
      <v-spacer />
      <v-select
        v-model="search"
        primary
        dark
        solo-inverted
        flat
        append-icon="pending_actions"
        class="ma-0 mr-4"
        :items="buyOfferStates"
        label="Buy Offer State"
        item-value="value"
        hide-details
        clearable
      />
      <v-text-field
        v-model="search"
        primary
        dark
        solo-inverted
        flat
        append-icon="search"
        label="Search buy offers ..."
        single-line
        hide-details
      />
    </v-card-title>

    <v-card-title class="filters grey lighten-5">
      <div class="filters__header">
        Filtered results ({{ filteredResults.length }} of {{ filteredItems.length }})
        <v-tooltip
          v-if="!hasResultFilters"
          top
          dark
        >
          <template v-slot:activator="{ on }">
            <v-btn
              dark
              flat
              icon
              color="secondary"
              v-on="on"
            >
              <v-icon>
                filter_list
              </v-icon>
            </v-btn>
          </template>
          <span>Filters</span>
        </v-tooltip>
        <v-tooltip
          v-else
          top
          dark
        >
          <template v-slot:activator="{ on }">
            <v-btn
              dark
              flat
              icon
              color="primary"
              v-on="on"
              @click="resetResultsFilters"
            >
              <v-icon>
                restore
              </v-icon>
            </v-btn>
          </template>
          <span>Reset filters</span>
        </v-tooltip>
      </div>
      <v-select
        v-model="resultFilters.providerType"
        class="ml-5"
        primary
        :items="providers"
        label="Asset provider"
        item-value="value"
        clearable
      />


      <v-text-field
        v-model="resultFilters.searchResults"
        class="ml-5"
        append-icon="search"
        label="Filter results"
      />
    </v-card-title>

    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="filteredResults"
      :total-items.sync="pagination.totalItems"
      :rows-per-page-items="rowsPerPageItems"
      :loading="loading"
      :expand="expand"
      item-key="id"
      class="elevation-1"
      :pagination.sync="pagination"
    >
      <template v-slot:items="props">
        <tr
          :active="props.selected"
          @click="toogleExpanded(props)"
        >
          <td>
            <v-checkbox
              :input-value="props.selected"
              color="primary"
              hide-details
              @change="toogleSelected(props)"
            />
          </td>
          <td class="text-xs-center">
            {{ props.item.id }}
          </td>
          <td class="text-xs-center">
            {{ props.item.user_id }}
          </td>
          <td class="text-xs-center">
            {{ formatFieldName(props.item.state) }}
          </td>
          <td class="text-xs-center">
            {{ formatFieldName(props.item.asset.provider) }}
          </td>
          <td class="text-xs-center">
            {{ props.item.asset.title }}
          </td>
          <td class="text-xs-center">
            {{ props.item.asset.asset_id }}
          </td>
          <td class="text-xs-center">
            {{ centsToEuros(props.item.total) }}
          </td>
          <td class="text-xs-center">
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-chip
                  color="grey"
                  outline
                  small
                  v-on="on"
                >
                  <span>
                    {{ formatDateSmall(props.item.created_at) }}
                  </span>
                </v-chip>
              </template>
              {{ formatDate(props.item.created_at) }}
            </v-tooltip>
          </td>
          <td class="text-xs-center">
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-chip
                  color="grey"
                  outline
                  small
                  v-on="on"
                >
                  <span>
                    {{ formatDateSmall(props.item.updated_at) }}
                  </span>
                </v-chip>
              </template>
              {{ formatDate(props.item.updated_at) }}
            </v-tooltip>
          </td>
        </tr>
      </template>
      <template v-slot:expand="props">
        <v-container
          cols="12"
          class="d-flex grey lighten-2"
          fluid
        >
          <v-card class="ma-2 pa-6">
            <v-card-title class="toolbar primary white--text subheading">
              <v-icon
                dark
                color="white"
              >
                swap_horiz
              </v-icon>
              <span>Buy offer details</span>
            </v-card-title>

            <v-card-text>
              <v-layout
                wrap
                class="pa-0 "
              >
                <v-flex
                  v-for="field in cleanFields(props.item)"
                  :key="field"
                  class="pa-2"
                >
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        <v-text-field
                          :label="formatFieldName(field, props.item)"
                          :value="formatValue(props.item[field], field)"
                          readonly
                          class="body-1"
                          :class="field"
                        />
                      </span>
                    </template>
                    <span>
                      field: {{ field }}
                    </span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>

          <v-card class="ma-2 pa-6">
            <v-card-title class="toolbar primary white--text subheading">
              <v-icon color="white">
                library_books
              </v-icon>
              <span> Asset details</span>
            </v-card-title>
            <v-card-text>
              <v-layout
                wrap
                class="pa-0 "
              >
                <v-flex
                  v-for="field in cleanFields(props.item.asset)"
                  :key="field"
                  class="pa-2"
                >
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        <v-text-field
                          :label="formatFieldName(field, props.item)"
                          :value="formatValue(props.item.asset[field], field)"
                          readonly
                          class="body-1"
                          :class="field"
                        />
                      </span>
                    </template>
                    <span>
                      field: {{ field }}
                    </span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-container>
      </template>
    </v-data-table>

    <v-dialog
      v-model="cancelModalOpen"
      width="600"
      persistent
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Cancel Selected Buy Offers
        </v-card-title>
        <v-card-text>
          Please confirm that you really want to <strong>cancel</strong>
          the next Buy Offer(s) ID(s):
          <strong>{{ selected.map(select => select.id).join(', ') }}</strong>
        </v-card-text>

        <v-form
          ref="tradeForm"
          @submit.prevent="cancelBuyOffers"
        >
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn
              flat
              @click="cancelModalOpen = false"
            >
              Close
            </v-btn>
            <e-button
              flat
              type="submit"
              color="blue"
              text="Cancel Buy Offer(s)"
              :loading="loading"
              @click="cancelModalOpen = true"
            />
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import _ from 'lodash';
import { mapActions } from 'vuex';
import { Button } from '@/components/shared';
import { toQueryString, setQuery } from '@/helpers';
import OfferStatesEnum from '@/enum/trades/OfferStates';
import AssetProvidersEnum from '@/enum/trades/AssetProviders';

export default {
  name: 'TradesTable',
  components: {
    'e-button': Button,
  },
  props: {
    buyoffers: {
      type: Array,
      default: () => [],
    },
    buyoffersPagination: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expand: false,
      cancelModalOpen: false,
      isLoadTableData: false,
      search: this.$route.query.search,
      selected: [],
      pagination: {
        page: parseFloat(this.$route.query.page),
        rowsPerPage: parseFloat(this.$route.query.limit),
        sortBy: this.$route.query.sort,
        descending: this.$route.query.dir === 'desc',
        totalItems: this.buyoffersPagination.total || 0,
      },
      rowsPerPageItems: [
        {
          text: '10',
          value: 10,
        },
        {
          text: '25',
          value: 25,
        },
        {
          text: '50',
          value: 50,
        },
        {
          text: '100',
          value: 100,
        },
      ],
      filters: {
        createdAt: [],
        state: [],
      },
      resultFilters: {
        assetType: null,
        providerType: null,
        searchResults: null,
      },
      headers: [
        {
          text: '',
          align: 'center',
          width: '20px',
        },
        {
          text: 'Buy offer id',
          align: 'center',
          value: 'id',
        },
        {
          text: 'User Id',
          align: 'center',
          sortable: false,
        },
        {
          text: 'State',
          align: 'center',
          value: 'state',
        },
        {
          text: 'Asset provider',
          value: 'asset.provider',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Project',
          align: 'center',
          value: 'asset.title',
          sortable: false,
        },
        {
          text: 'Asset Id',
          value: 'asset.asset_id',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Total',
          align: 'center',
          value: 'total',
        },
        {
          text: 'Created at',
          value: 'created_at',
          align: 'center',
        },
        {
          text: 'Updated at',
          value: 'updated_at',
          align: 'center',
        },
      ],
    };
  },
  computed: {
    filteredItems() {
      return this.buyoffers.filter(d => Object.keys(this.filters).every((f) => {
        if (this.filters[f]) {
          return (
            this.filters[f].length < 1 ||
            String(this.filters[f]).includes(d[f])
          );
        }

        return true;
      }));
    },
    filteredResults() {
      if (this.hasResultFilters) {
        return this.filteredItems.filter((item) => {
          let hasProvider = false;
          let hasAssetType = false;
          let hasSearch = false;

          const { providerType, assetType, searchResults } = this.resultFilters;

          if (providerType) {
            hasProvider = item.asset.provider === providerType;
          }
          if (assetType) {
            hasAssetType = item.asset.type === assetType;
          }

          if (searchResults) {
            hasSearch = JSON.stringify(item)
              .toLowerCase()
              .includes(searchResults.toLowerCase());
          }

          return (!!hasProvider || !!hasAssetType || !!hasSearch) || false;
        });
      }

      return this.filteredItems;
    },

    buyOfferStates() {
      return Object.keys(OfferStatesEnum).map(key => ({
        text: this.formatFieldName(OfferStatesEnum[key]),
        value: OfferStatesEnum[key],
      }));
    },
    providers() {
      return Object.keys(AssetProvidersEnum).map(key => ({
        text: this.formatFieldName(AssetProvidersEnum[key]),
        value: AssetProvidersEnum[key],

      }));
    },
    hasResultFilters() {
      return !!this.resultFilters.providerType
        || !!this.resultFilters.assetType
        || !!this.resultFilters.searchResults;
    },
  },
  watch: {
    buyoffersPagination: {
      immediate: false,
      async handler(pagination) {
        if (pagination) {
          this.pagination.page = pagination.page;
          this.pagination.rowsPerPage = pagination.limit;
          this.pagination.totalItems = pagination.total;
          this.pagination.descending = pagination.direction === 'DESC';
          this.pagination.sortBy = pagination.sort;
        }
      },
    },
    search: {
      immediate: false,
      handler(search, oldSearch) {
        if (search !== oldSearch) {
          setQuery(
            {
              search,
            },
            this.$route,
            this.$router,
          );
        }
      },
    },
    $route: {
      immediate: false,
      handler() {
        this.fetchTableData();
      },
    },
    pagination: {
      immediate: false,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.updatePagination(newVal);
        }
      },
    },
  },
  methods: {
    ...mapActions(['fetchBuyOffers', 'cancelBuyOffersAction']),
    fetchTableData() {
      const query = toQueryString(this.$route.query);

      if (typeof window.LIT !== 'undefined') {
        clearTimeout(window.LIT);
      }

      window.LIT = setTimeout(() => {
        this.fetchBuyOffers(query);
      }, 100);
    },
    formatDate(date) {
      return this.$moment(date).format('MMMM Do YYYY, h:mm:ss a');
    },
    formatDateSmall(date) {
      return this.$moment(date).format('DD/MM/YYYY');
    },
    centsToEuros(amount) {
      amount = `${parseInt(amount, 0) / 100}`;

      return `${parseFloat(amount).toFixed(2)} €`;
    },

    async cancelBuyOffers() {
      const data = { ids: this.selected.map(v => v.id) };
      await this.cancelBuyOffersAction(data);

      this.cancelModalOpen = false;
      this.selected = [];
    },
    toogleSelected(props) {
      props.selected = !props.selected;
    },
    toogleExpanded(props) {
      props.expanded = !props.expanded;
    },

    /**
     * removes keys from object if value is falsy or typeof object
     */
    cleanFields(data) {
      return Object.keys(data)
        .filter(field => !!data[field] && typeof data[field] !== 'object');
    },
    updatePagination(pagination) {
      if (!pagination.page) {
        return null;
      }

      setQuery(
        {
          page: pagination.page,
          sort: pagination.sortBy,
          dir: pagination.descending ? 'desc' : 'asc',
          limit: pagination.rowsPerPage,
          search: this.search,
        },
        this.$route,
        this.$router,
      );

      return this.fetchTableData();
    },
    formatFieldName(str, item) {
      const camelCaseSentence = str.replace(/([-_]\w)/g, g => g[1].toUpperCase());
      const sentence = _.startCase(camelCaseSentence);

      if (item) {
        if (str === 'security_wallet' && item.asset.provider === 'baaderbank') {
          return `${_.capitalize(sentence)} / Baader Bank account`;
        }
      }

      return _.capitalize(sentence);
    },

    formatValue(value, key) {
      if (key === 'total' || key === 'unit_price') {
        return this.centsToEuros(value);
      }
      if (key.includes('_at')) {
        return this.formatDate(value);
      }

      return value;
    },

    resetResultsFilters() {
      this.resultFilters = _.mapValues(this.resultFilters, () => null);
    },
  },
};
</script>

<style lang="scss" scoped>
.buyoffers-table{
  a {
    text-decoration: none;
    color: black;
  }

  .toolbar {
    background-color: #1a4c7d;
    color: white;
  }

  .infoLabel {
    margin-left: 16px;
  }

  .countLabel {
    color: #fff;
  }
  .expanded-details {
    background-color: #eaeaea;
    padding: 20px;
  }

  .v-select{
        flex: 1;
  }

  table.v-table {
    td,
    th {
      padding: 0 1% !important;
    }
  }

  .v-card__title.subheading{
    .v-icon{
      margin-right:10px;
    }
  }
  .v-input{
    &.security_wallet{
      min-width: 350px;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/trades/BuyOffersTable.vue